function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareIconinline = function SvgShareIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 12,
    viewBox: "0 0 11 12"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 8a1.991 1.991 0 0 0-1.431.606L3.922 6.522a1.8 1.8 0 0 0 0-1.044l3.647-2.084A2 2 0 1 0 7 2a1.983 1.983 0 0 0 .078.523L3.431 4.606a2 2 0 1 0 0 2.788l3.647 2.084A1.979 1.979 0 0 0 7 10a2 2 0 1 0 2-2Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};
export default SvgShareIconinline;